// Module
var code = `
<i class="fa-solid {{iconClass}}"></i>
<h3 class="title">{{title}}</h3>
<p class="desc">{{desc}}</p>

`;
// Exports
module.exports = code;